import {
    IncentivizeRewardsDto,
    SpoolDto,
    UserIncentivizedRewardsDto,
} from '../../types/spool-local';
import { ethers } from 'ethers';

type AvailableSpool = SpoolDto & {
    incentivizedRewards: IncentivizeRewardsDto[];
    userData:
        | {
              userIncentivizedRewards: UserIncentivizedRewardsDto[];
              id: string;
              user: Address;
              pendingDepositAmount: number;
              pendingWithdrawalAmount: number;
              userClaimableAmount: number;
              userYieldEarnedToDateAmount: number;
              userCurrentBalance: number;
              userShares: string;
          }
        | undefined;
};

export const AVAILABLE_SPOOLS: AvailableSpool[] = [
    {
        address: ethers.constants.AddressZero,
        adjustedApy: '0.3',
        apy: '0.2',
        asset: {
            decimals: 18,
            id: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
            name: 'USDC',
            symbol: 'USDC',
        },
        baseApy: '0.19',
        creator: ethers.constants.AddressZero,
        dateCreated: '1763168089',
        incentivizedRewards: [
            {
                apy: '0.1',
                decimals: 18,
                emissionEndDate: '1765168089',
                emissionStartDate: '1764168089',
                id: ethers.constants.AddressZero,
                isRemoved: false,
                name: 'BNB',
                remainingAmount: '10000',
                rewardRate: '100',
                symbol: 'BNB',
                totalAmount: '100000',
                totalEmissionDays: '36',
            },
        ],
        name: 'Spool Test Vault 1',
        owner: ethers.constants.AddressZero,
        ownerFeesCollectedAmount: '100',
        performanceFees: {
            ecosystem: '100',
            owner: '200',
            riskProvider: '300',
            treasury: '400',
        },
        riskModelAddress: '0xc216ad6280f4fa92a5159ef383a1206d432481c8',
        riskTolerance: '7',
        strategies: [
            {
                address: ethers.constants.AddressZero,
                allocation: '10',
                id: ethers.constants.AddressZero,
                position: 1,
            },
        ],
        totalFeesCollectedAmount: '200',
        totalShares: '100000',
        tvr: '112321213',
        userData: {
            id: ethers.constants.AddressZero,
            pendingDepositAmount: 1233,
            pendingWithdrawalAmount: 100,
            user: ethers.constants.AddressZero,
            userClaimableAmount: 444,
            userCurrentBalance: 111,
            userIncentivizedRewards: [
                {
                    claimableAmount: '233',
                    claimedAmount: '11',
                    token: {
                        decimals: 18,
                        id: ethers.constants.AddressZero,
                        name: 'BNB',
                        symbol: 'BNB',
                    },
                    usdValue: '444',
                    isRemoved: false,
                },
            ],
            userShares: '4444',
            userYieldEarnedToDateAmount: 111,
        },
    },
    {
        address: '0x0000000000000000000000000000000000000001',
        adjustedApy: '0.3',
        apy: '0.2',
        asset: {
            decimals: 18,
            id: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
            name: 'USDC',
            symbol: 'USDC',
        },
        baseApy: '0.19',
        creator: ethers.constants.AddressZero,
        dateCreated: '1763168089',
        incentivizedRewards: [
            {
                apy: '0.1',
                decimals: 18,
                emissionEndDate: '1765168089',
                emissionStartDate: '1764168089',
                id: ethers.constants.AddressZero,
                isRemoved: false,
                name: 'BNB',
                remainingAmount: '10000',
                rewardRate: '100',
                symbol: 'BNB',
                totalAmount: '100000',
                totalEmissionDays: '36',
            },
        ],
        name: 'Spool Second Test Vault',
        owner: ethers.constants.AddressZero,
        ownerFeesCollectedAmount: '100',
        performanceFees: {
            ecosystem: '100',
            owner: '200',
            riskProvider: '300',
            treasury: '400',
        },
        riskModelAddress: '0xc216ad6280f4fa92a5159ef383a1206d432481c8',
        riskTolerance: '7',
        strategies: [
            {
                address: ethers.constants.AddressZero,
                allocation: '10',
                id: ethers.constants.AddressZero,
                position: 1,
            },
        ],
        totalFeesCollectedAmount: '200',
        totalShares: '100000',
        tvr: '112321213',
        userData: {
            id: ethers.constants.AddressZero,
            pendingDepositAmount: 1233,
            pendingWithdrawalAmount: 100,
            user: ethers.constants.AddressZero,
            userClaimableAmount: 444,
            userCurrentBalance: 111,
            userIncentivizedRewards: [
                {
                    claimableAmount: '233',
                    claimedAmount: '11',
                    token: {
                        decimals: 18,
                        id: ethers.constants.AddressZero,
                        name: 'BNB',
                        symbol: 'BNB',
                    },
                    usdValue: '444',
                    isRemoved: false,
                },
            ],
            userShares: '4444',
            userYieldEarnedToDateAmount: 111,
        },
    },
];

export const USER_SPOOLS: SpoolDto[] = [
    {
        address: ethers.constants.AddressZero,
        adjustedApy: '0.3',
        apy: '0.2',
        asset: {
            decimals: 18,
            id: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
            name: 'USDC',
            symbol: 'USDC',
        },
        baseApy: '0.19',
        creator: ethers.constants.AddressZero,
        dateCreated: '1763168089',
        incentivizedRewards: [
            {
                apy: '0.1',
                decimals: 18,
                emissionEndDate: '1765168089',
                emissionStartDate: '1764168089',
                id: ethers.constants.AddressZero,
                isRemoved: false,
                name: 'BNB',
                remainingAmount: '10000',
                rewardRate: '100',
                symbol: 'BNB',
                totalAmount: '100000',
                totalEmissionDays: '36',
            },
        ],
        name: 'Spool Test Vault 1',
        owner: ethers.constants.AddressZero,
        ownerFeesCollectedAmount: '100',
        performanceFees: {
            ecosystem: '100',
            owner: '200',
            riskProvider: '300',
            treasury: '400',
        },
        riskModelAddress: '0xc216ad6280f4fa92a5159ef383a1206d432481c8',
        riskTolerance: '7',
        strategies: [
            {
                address: ethers.constants.AddressZero,
                allocation: '10',
                id: ethers.constants.AddressZero,
                position: 1,
            },
        ],
        totalFeesCollectedAmount: '200',
        totalShares: '100000',
        tvr: '112321213',
        userData: {
            id: ethers.constants.AddressZero,
            pendingDepositAmount: 1233,
            pendingWithdrawalAmount: 100,
            user: ethers.constants.AddressZero,
            userClaimableAmount: 444,
            userCurrentBalance: 111,
            userIncentivizedRewards: [
                {
                    claimableAmount: '233',
                    claimedAmount: '11',
                    token: {
                        decimals: 18,
                        id: ethers.constants.AddressZero,
                        name: 'BNB',
                        symbol: 'BNB',
                    },
                    usdValue: '444',
                    isRemoved: false,
                },
            ],
            userShares: '4444',
            userYieldEarnedToDateAmount: 111,
        },
    },
    {
        address: '0x0000000000000000000000000000000000000001',
        adjustedApy: '0.3',
        apy: '0.2',
        asset: {
            decimals: 18,
            id: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
            name: 'USDC',
            symbol: 'USDC',
        },
        baseApy: '0.19',
        creator: ethers.constants.AddressZero,
        dateCreated: '1763168089',
        incentivizedRewards: [
            {
                apy: '0.1',
                decimals: 18,
                emissionEndDate: '1765168089',
                emissionStartDate: '1764168089',
                id: ethers.constants.AddressZero,
                isRemoved: false,
                name: 'BNB',
                remainingAmount: '10000',
                rewardRate: '100',
                symbol: 'BNB',
                totalAmount: '100000',
                totalEmissionDays: '36',
            },
        ],
        name: 'Spool Second Test Vault',
        owner: ethers.constants.AddressZero,
        ownerFeesCollectedAmount: '100',
        performanceFees: {
            ecosystem: '100',
            owner: '200',
            riskProvider: '300',
            treasury: '400',
        },
        riskModelAddress: '0xc216ad6280f4fa92a5159ef383a1206d432481c8',
        riskTolerance: '7',
        strategies: [
            {
                address: ethers.constants.AddressZero,
                allocation: '10',
                id: ethers.constants.AddressZero,
                position: 1,
            },
        ],
        totalFeesCollectedAmount: '200',
        totalShares: '100000',
        tvr: '112321213',
        userData: {
            id: ethers.constants.AddressZero,
            pendingDepositAmount: 1233,
            pendingWithdrawalAmount: 100,
            user: ethers.constants.AddressZero,
            userClaimableAmount: 444,
            userCurrentBalance: 111,
            userIncentivizedRewards: [
                {
                    claimableAmount: '233',
                    claimedAmount: '11',
                    token: {
                        decimals: 18,
                        id: ethers.constants.AddressZero,
                        name: 'BNB',
                        symbol: 'BNB',
                    },
                    usdValue: '444',
                    isRemoved: false,
                },
            ],
            userShares: '4444',
            userYieldEarnedToDateAmount: 111,
        },
    },
];
